import React, { createContext, useContext, useEffect, useState } from 'react';

export interface LocalStorageContextProps {
  withLocalStorage: (key: string, value?: any) => any;
  removeLocalStorage: (keys: any) => void;
}

export const LocalStorageContext =
  createContext<LocalStorageContextProps | null>(null);

export const LocalStorageProvider = ({
  children,
}: {
  children: React.ReactNode;
}) => {
  const [loading, setLoading] = useState(true);

  const withLocalStorage = (key: string, value?: any): any => {
    let keyValue = value;
    if (value) {
      localStorage.setItem(key, value);
    } else {
      const saved = localStorage.getItem(key);
      keyValue = saved ? saved : value;
    }
    return keyValue;
  };

  const removeLocalStorage = (keys: any) => {
    if (keys.length) {
      keys.forEach((key: string) => {
        localStorage.removeItem(key);
      });
    }
  };

  useEffect(() => {
    setLoading(false);
  }, []);

  if (loading) {
    return null;
  }
  return (
    <LocalStorageContext.Provider
      value={{
        withLocalStorage,
        removeLocalStorage,
      }}
    >
      {children}
    </LocalStorageContext.Provider>
  );
};

export function useLocalStorage(): LocalStorageContextProps {
  const context = useContext(LocalStorageContext);
  return context || assertNever();
}

function assertNever(): never {
  throw Error('Cannot use useLocalStorage outside of LocalStorageProvider');
}
